import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_filter_item_selector = _resolveComponent("filter-item-selector");
  const _component_dropdown_body = _resolveComponent("dropdown-body");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  return _openBlock(), _createElementBlock("div", {
    id: $props.id,
    ref: "filterItemWrapper",
    class: "filter-item-wrapper"
  }, [_createVNode(_component_b_dropdown, {
    ref: "filterDropdown",
    offset: "8",
    "no-caret": "",
    onHidden: _cache[2] || (_cache[2] = $event => _ctx.$emit('hidden')),
    strategy: "fixed"
  }, {
    "button-content": _withCtx(() => [_createVNode(_component_filter_item_selector, {
      id: $props.id,
      icon: $props.icon,
      color: $props.color,
      iconSize: $props.iconSize,
      title: $options.getComputedTitle,
      selectedTitle: $props.selectedTitle,
      selectedCount: $props.selectedCount,
      onClearAll: _cache[0] || (_cache[0] = $event => _ctx.$emit('clearAll')),
      onApply: _cache[1] || (_cache[1] = $event => _ctx.$emit('apply')),
      noCount: $props.noCount,
      no_reset: $props.no_reset
    }, _createSlots({
      _: 2
    }, [_ctx.$slots.title ? {
      name: "title",
      fn: _withCtx(() => [_renderSlot(_ctx.$slots, "title")]),
      key: "0"
    } : undefined]), 1032, ["id", "icon", "color", "iconSize", "title", "selectedTitle", "selectedCount", "noCount", "no_reset"])]),
    default: _withCtx(() => [_createVNode(_component_dropdown_body, {
      class: "filter-dropdown-body"
    }, {
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "body", _normalizeProps(_guardReactiveProps(_ctx.$attrs)))]),
      _: 3
    })]),
    _: 3
  }, 512)], 8, _hoisted_1);
}